export default function LocalFocus() {
  return (
    <section id="local-focus" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <i className="ri-map-pin-2-line text-teal-600 text-xl"></i>
            <span className="text-sm font-semibold tracking-widest text-gray-500 uppercase">Local Focus</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-5">Rooted in Silicon Valley</h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            Blu-Point is not a national chain dispatching crews from a call center. We are a locally owned and operated company, based right here in Silicon Valley — and that makes all the difference.
          </p>
        </div>

        {/* Intro Text + Photo 1 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-5 leading-snug">
              We Know This Community Because We Are Part of It
            </h3>
            <p className="text-gray-600 text-base leading-relaxed mb-4">
              Our team lives and works in the same neighborhoods we serve. From Sunnyvale to San Jose, from Palo Alto to Fremont, we understand the pace, the standards, and the expectations of Silicon Valley property owners. When you call us, you reach someone local — not a national hotline.
            </p>
            <p className="text-gray-600 text-base leading-relaxed">
              Being local means we can respond quickly, build real relationships, and stay accountable in ways that large national companies simply cannot. Our reputation in this community is everything to us, and we protect it on every job.
            </p>
          </div>

          {/* Photo Slot 1 */}
          <div className="relative rounded-3xl overflow-hidden h-72 w-full">
            <img
              src="https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/1e6f57266a70b89c4e4b85d05d545e12.jpeg"
              alt="Local Silicon Valley restaurant"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Photos 2, 3, 4, 5 — 2x2 grid */}
        <div className="grid grid-cols-2 gap-6 mb-20">
          <div className="relative rounded-3xl overflow-hidden h-72 w-full">
            <img
              src="https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/12472182300afb6fd849d76c9d5a705c.jpeg"
              alt="Silicon Valley commercial property"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative rounded-3xl overflow-hidden h-72 w-full">
            <img
              src="https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/9ec6cc6324e204826bf895ea7ed7b06f.jpeg"
              alt="Industrial warehouse facility"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative rounded-3xl overflow-hidden h-72 w-full">
            <img
              src="https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/54c51278ea33e1c51fccb17ea4892719.jpeg"
              alt="Silicon Valley retail shopping center"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative rounded-3xl overflow-hidden h-72 w-full">
            <img
              src="https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/a1e91075d932319cef9ddcf5742a1edc.jpeg"
              alt="Silicon Valley office building at dusk"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

      </div>
    </section>
  );
}
